module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements and Thanks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("1. The Early Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter2#C2"
    }
  }, [_vm._v("2. Archmere and Delaware")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Starting a Family and a Career")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The First Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Road to the Senate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Unspeakable Tragedy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Senate and “Amtrak Joe”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Jill Biden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#C9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Victory Repeated")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10#C10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Institutions and Allies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11#C11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Homes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12#C12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. On the Town")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13#C13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Kids")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14#C14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Eyes on the Prize")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15#C15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Professor Biden and Beau’s Rise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16#C16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Vice Presidency")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17#C17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Beau’s Death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18#C18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Faith and Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19#C19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. A Short-Lived Retirement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20#C20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Delaware Beaches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21#C21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. One of Us")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0